package org.moxultimate.topwithmox.shows.data

import kotlinx.serialization.Serializable

/**
 * ShowsTypeResponse
 * API response model for a single type entry from GET /shows-type.
 */
@Serializable
data class ShowsTypeResponse(
    val id: Long,
    val type: String? = null,
)
